import DispatchCancelIcon from './DispatchCancelIcon';
import { isDispatchCancelled } from '../util';
import { withDynamicStyles } from './WithDynamicStyles';
const styles = (theme) => ({
  cardContainer: {
    float: "left",
    fontSize: 11,
    fontWeight: 600,
    marginLeft: 40,
    color: theme.iconColor,
    display: 'flex',
    alignItems: 'center'
  },
  dispatchCancelIcon: {
    pointerEvents: 'auto',
    marginLeft: 8
  }
});
const DriverRouteCard = ({ data, classes }) => {
  const isCancelledDispatch = isDispatchCancelled(data.routeData);
  return (
    <div className={classes.cardContainer}>
      {data.text}{' '}
      {isCancelledDispatch && (
        <div className={classes.dispatchCancelIcon}>
          <DispatchCancelIcon isGanttGridIcon routeData={data.routeData} />
        </div>
      )}
    </div>
  );
};

export default withDynamicStyles(styles)(DriverRouteCard);
